export default __webpack_public_path__ + "static/media/feintattack8.edcbd0df.png";